import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import OnlineWebinarView from 'components/Webinar/OnlineWebinar';
import actions from 'actions';
import constants from 'constants';
import storage from 'services/storage.js'

const {
  loadVimeoVideoDataSaga,
  showModal,
  loadWebinarSaga
} = actions;

const {
  MODAL_TYPE_QUIZ
} = constants;

class OnlineWebinar extends Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const webinarId = parseInt(
      (this.props.params && this.props.params.id) || ''
    );
    this.props.loadWebinar(webinarId)
  }

  showQuizModal = () => {
    this.props.showQuizModal({
      webinar: this.props.webinar
    })
  }

  render() {
    const token = storage.getSessionData().session.token;
    return (
      <div>
        <OnlineWebinarView
          token={token}
          webinar={this.props.webinar}
          videoData={this.props.videoData(this.props.webinar.vimeo_url)}
          startQuiz={this.showQuizModal}
          userRole={this.props.userRole}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  videoData: (uid) => state.vimeo[uid],
  webinar: state.webinars.tmp,
  userRole: state.users.user.user_type
})

const mapDispatchToProps = (dispatch) => ({
  showQuizModal: (contentProps) => dispatch(showModal(MODAL_TYPE_QUIZ, contentProps)),
  loadWebinar: (webinarId) => dispatch(loadWebinarSaga(webinarId, true, true, true))
})

export default connect(mapStateToProps, mapDispatchToProps)(OnlineWebinar);



/** WEBPACK FOOTER **
 ** ./src/containers/Webinar/OnlineWebinar.jsx
 **/